import React from 'react';
import { RightSignIcon } from '../../../components/common/SvgIcon';

const PositionPreview = ({ config, selected, onSelect }) => {
  const isSelected = selected === config.value;
  const bar = config.bars[0];

  return (
    <button
      type="button"
      onClick={() => onSelect(config.value)}
      className={[
        'relative flex flex-col gap-2 rounded-xl border-1 p-3 w-full transition cursor-pointer text-left',
        isSelected
          ? 'border-[#7C3BED] bg-[#F5F0FF]'
          : 'border-[#E4E4E7] bg-white hover:border-[#C4B5FD]',
      ].join(' ')}
    >
      {/* Label row */}
      <span className={[
        'text-xs font-semibold flex items-center justify-between gap-1',
        isSelected ? 'text-[#7C3BED]' : 'text-[#17171C]',
      ].join(' ')}>
        {config.label}
        {isSelected && (
          <RightSignIcon />
        )}
      </span>

      {/* Mini preview box */}
      <div className="relative w-full h-10 rounded-md bg-[#F4F4F5] overflow-hidden">
        {/* Purple bar */}
        <div
          className="absolute bg-[#A78BFA] rounded-sm"
          style={{
            height: '7px',
            width: bar.full ? 'calc(100% - 8px)' : '35%',
            [bar.pos]: '4px',
            left:  bar.full ? '4px' : bar.align === 'right' ? 'auto' : '4px',
            right: bar.align === 'right' ? '4px' : 'auto',
          }}
        />
      </div>
    </button>
  );
};

export default PositionPreview;